import React from "react"
import { MapLocationContainer } from "containers"
import { gtmFindADealerActionTypes } from "store/gtm-events"

const MapSearchBlock = props => (
  <MapLocationContainer
    searchType="search"
    gtmMapping={gtmFindADealerActionTypes}
    mapFixedHeight
    flexSizing
    mapFixHeightStyle={{
      height: "60vh",
      minHeight: "500px"
    }}
    {...props} />
)

export default MapSearchBlock



// WEBPACK FOOTER //
// ./src/blocks/map-search/index.jsx